module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"nl-BE":{"title":"SSO Login","welcome":"Click on the button to log in","login":"Log In"},"en-BE":{"title":"SSO Login","welcome":"Click on the button to log in","login":"Log In"},"fr-BE":{"title":"SSO Login","welcome":"Click on the button to log in","login":"S\u0027identifier"}}')
  delete Component.options._Ctor
}
